"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.obfuscateText = exports.OBFUSCATION_CHAR = void 0;
exports.OBFUSCATION_CHAR = '*';
function obfuscateText(text, lengthToReveal) {
    if (lengthToReveal === void 0) { lengthToReveal = 2; }
    if (lengthToReveal >= text.length) {
        return exports.OBFUSCATION_CHAR.repeat(text.length);
    }
    var obfuscatedLength = text.length - lengthToReveal;
    return exports.OBFUSCATION_CHAR.repeat(obfuscatedLength) + text.slice(obfuscatedLength);
}
exports.obfuscateText = obfuscateText;
//# sourceMappingURL=obfuscation.js.map